import sistema from "./sistema/siccij"
import funciones from './funcion/siccij'
import catalogos from "./catalogos/siccij"


const siccij = {
  funciones: funciones,
  catalogos:catalogos,
  sistema: sistema
}

export default siccij;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICCIJ/siccijapi.js
// module id = null
// module chunks = 